module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter",
      "title": "III. Theme of the Epistle"
    }
  }, [_c('p', {
    staticClass: "chap_title"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_26",
      "title": "26"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/v1_Contents#i11",
      "id": "ri11"
    }
  }, [_vm._v("III. THEME OF THE EPISTLE")])])]), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_c('b', [_vm._v("1:16, 17")])]), _vm._v(" "), _c('div', {
    staticClass: "num1"
  }, [_c('p', {
    staticClass: "number1"
  }, [_vm._v("16"), _c('span', {
    staticClass: "num"
  }, [_vm._v("For I am not ashamed of the gospel: for it is the power of God unto salvation to every one that believeth; to the Jew first, and also to the Greek.")])]), _vm._v(" "), _c('p', {
    staticClass: "number1"
  }, [_vm._v("17"), _c('span', {
    staticClass: "num"
  }, [_vm._v("For therein is revealed a righteousness of God from faith unto faith: as it is written, But the righteous shall live by faith.")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para_ts"
  }, [_c('b', [_vm._v("16, 17")]), _vm._v(" In the preceding verse the apostle had affirmed that to the full extent of his own resolution and purpose he was prepared to preach the gospel at Rome. In verses 16, 17 he gives the reason for this determination. We might think that the negative way of expressing his estimate of the gospel, “I am not ashamed of the gospel”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn11-20"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/v1_Chapter03#fn11-20"
    }
  }, [_vm._v("20")])]), _vm._v(" is scarcely consistent with the confident glorying which appears on other occasions ("), _c('i', [_vm._v("cf")]), _vm._v(". 5:2, 3, 11; Gal. 6:14) or with the confidence in the efficacy of the gospel enunciated later in these same verses. But when we remember the contempt entertained for the gospel by the wise of this world ("), _c('i', [_vm._v("cf")]), _vm._v(". I Cor. 1:18, 23–25) and also of the fact that Rome as the seat of world empire was the epitome of worldly power, we can discover the significance of this negative expression and the undertone of assurance which the disavowal reflects. The emotion of shame with reference to the gospel, when confronted with the pretensions of human wisdom and power, betrays unbelief in the truth of the gospel and the absence of shame is the proof of faith ("), _c('i', [_vm._v("cf")]), _vm._v(". Mark 8:38; II Tim. 1:8).")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("There is a continuous and progressive unfolding of reasons in this text. The apostle tells us first why he is ready to preach the gospel at Rome—he is not ashamed of the gospel. Then he tells us why he is not ashamed of the gospel—it is “the power of God unto salvation”. And then, finally, he tells us why it is the power of God unto salvation—therein the “righteousness of God is revealed”.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_27",
      "title": "27"
    }
  }, [_vm._v("When we read, “it is the power of God unto salvation”, the subject is undoubtedly the gospel. The gospel is the message. It is, of course, always a message proclaimed but the gospel itself is the message. We must not therefore overlook the plain import of this proposition that the message of the gospel is the power of God unto salvation; God saves through the message of the gospel ("), _c('i', [_vm._v("cf")]), _vm._v(". I Cor. 1:21). And the implication is that God’s power as it is operative unto salvation is through the gospel alone. It is the "), _c('i', [_vm._v("gospel")]), _vm._v(" that is God’s power unto salvation. The message is God’s word, and the word of God is living and powerful ("), _c('i', [_vm._v("cf")]), _vm._v(". Heb. 4:12).")])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("“The power of God” is the power that belongs to God and therefore the power characterized by those qualities that are specifically divine. In order to express the thought we should have to say the omnipotence of God and, consequently, the meaning is no less than this that the gospel is the omnipotence of God operative unto salvation. And “salvation” will have to be understood both negatively and positively, as salvation from sin and death unto righteousness and life. The various aspects comprised in this “salvation” are developed in the epistle.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("The power of God unto salvation of which the gospel is the embodiment is not unconditionally and universally operative unto salvation. It is of this we are advised in the words “to every one that believeth”. This informs us that salvation is not accomplished irrespective of faith."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn11-21"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/v1_Chapter03#fn11-21"
    }
  }, [_vm._v("21")])]), _vm._v(" Hence the salvation with which Paul is going to deal in this epistle has no reality, validity, or meaning apart from faith. And we are already prepared for the emphasis which is placed upon faith throughout the epistle. The concept "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_28",
      "title": "28"
    }
  }, [_vm._v("of salvation developed in this epistle, therefore, is "), _c('i', [_vm._v("the power of God operative unto salvation through faith")]), _vm._v(". It is this salvation that is proclaimed in the gospel and the gospel as message is the embodiment of this power.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("We must not discount the emphasis that the gospel is unto salvation to "), _c('i', [_vm._v("every one")]), _vm._v(" that believes. This is directly germane to the character of the gospel and to the meaning of faith. There is no discrimination arising from race or culture and there is no obstacle arising from the degradations of sin. Wherever there is faith, "), _c('i', [_vm._v("there")]), _vm._v(" the omnipotence of God is operative unto salvation. This is a law with no exceptions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("“To the Jew first, and also to the Greek.” Since Paul was the apostle to the Gentiles and since the church at Rome was preponderantly Gentile ("), _c('i', [_vm._v("cf")]), _vm._v(". vs. 13), it is the more significant that he should have intimated so expressly the priority of the Jew. But it was the divine economy that the gospel should have been preached first of all to the Jew ("), _c('i', [_vm._v("cf.")]), _vm._v(" Luke 24:49; Acts 1:4, 8; 13:46). It does not appear sufficient to regard this priority as that merely of time. In this text there is no suggestion to the effect that the priority is merely that of time. The implication appears to be rather that the power of God unto salvation through faith has primary relevance to the Jew, and the analogy of Scripture would indicate that this peculiar relevance to the Jew arises from the fact that the Jew had been chosen by God to be the recipient of the promise of the gospel and that to him were committed the oracles of God. Salvation was of the Jews (John 4:22; "), _c('i', [_vm._v("cf.")]), _vm._v(" Acts 2:39; Rom. 3:1, 2; 9:4, 5). The lines of preparation for the full revelation of the gospel were laid in Israel and for that reason the gospel is pre-eminently the gospel for the Jew. How totally contrary to the current attitude of Jewry that Christianity is for the Gentile but not for the Jew.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("This priority that belongs to the Jew does not make the gospel less relevant to the Gentile—“and also to the Greek”. The Gentile as fully as the Jew is the recipient of salvation and so, in respect of the favour enjoyed, there is no discrimination. The term “Greek” in this connection means all races other than Jews and includes the “Greeks and Barbarians” of verse 14.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("In verse 17 we are given the reason why the gospel is the power of God unto salvation. And the reason is that in the gospel “is revealed a righteousness of God”. It needs to be observed "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_29",
      "title": "29"
    }
  }, [_vm._v("how the concepts with which the apostle here deals are analogous to and no doubt derived from the Old Testament. Four pivotal ideas are coordinated in these verses—the power of God, salvation, revelation, and the righteousness of God. In the Old Testament we find these same ideas brought together in a way of which verses 16, 17 are plainly reminiscent. “Oh sing unto the Lord a new song; for he hath done marvellous things: his right hand, and his holy arm, hath wrought salvation for him. The Lord hath made known his salvation: his righteousness hath he openly showed in the sight of the nations” (Ps. 98:1, 2). “I will bring near my righteousness; it shall not be far off, and my salvation shall not tarry: and I will place salvation in Zion for Israel my glory” (Isa. 46:13). “My righteousness is near; my salvation is gone forth . . . my salvation shall be for ever, and my righteousness shall not be abolished . . . my righteousness shall be for ever, and my salvation from generation to generation” (Isa. 51:5–8). “My salvation is near to come, and my righteousness to be revealed” (Isa. 56:1). “For Zion’s sake will I not hold my peace, and for Jerusalem’s sake I will not rest, until the righteousness thereof go forth as brightness, and the salvation thereof as a lamp that burneth” (Isa. 62:1). ("), _c('i', [_vm._v("Cf")]), _vm._v(". also Isa. 54:17; 61:10, 11). It is apparent that the making known of salvation and the showing forth or revelation of righteousness are parallel expressions and convey substantially the same thought. Hence in the language of the Old Testament the salvation of God and the righteousness of God in such contexts are virtually synonymous—the working of salvation and the revelation of righteousness are to the same effect. It is this same complementation that we find here. And this is why the apostle can say that the gospel is the power of God unto salvation: “for therein is revealed a righteousness of God”.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("In line with the force of the term “revealed” in these Old Testament passages we shall have to give to the word here (vs. 17) a dynamic meaning. When the prophet spoke of the righteousness of God as being “revealed” he meant more than that it was to be disclosed to human apprehension. He means that it was to be revealed in action and operation; the righteousness of God was to be made manifest with saving effect. So, when the apostle says, the “righteousness of God is revealed”, he means that in the gospel the righteousness of God is actively and dynamically brought to bear upon man’s sinful situation; it is not merely that "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_30",
      "title": "30"
    }
  }, [_vm._v("it is made known as to its character to human apprehension but that it is manifest in its saving efficacy. This is why the gospel is the power of God unto salvation—the righteousness of God is redemptively active in the sphere of human sin and ruin.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("What is this “righteousness of God”? “The righteousness of God” sometimes denotes the attribute of righteousness, God’s rectitude ("), _c('i', [_vm._v("cf")]), _vm._v(". 3:5, 25, 26). In this instance, however ("), _c('i', [_vm._v("cf")]), _vm._v(". 3:21, 22; 10:3; II Cor. 5:21; Phil. 3:9), the righteousness in view is one that is brought to bear upon us unto salvation, and it is one to which faith bears the same relation as it does to the power of God operative unto salvation. While it is true that God’s attribute of justice cannot be violated in the salvation which we enjoy and while faith that is unto salvation cannot be divorced from belief in God’s rectitude, yet it is not the mere attribute of justice that effects our salvation (of itself it would seal our damnation), and it is not to the mere rectitude of God that saving faith is directed. Hence the righteousness of God in this instance must be something other than the attribute of justice. Justification is the theme of this epistle, and in these two verses the apostle is giving us an introductory summary of his leading thesis. The righteousness of God is therefore the righteousness of God that is unto our justification, the righteousness which he calls later on the free gift of righteousness (5:17), the “one righteousness” (5:18), “the obedience of the one” (5:19). We must, however, inquire more closely as to the import of this designation “the righteousness of God”.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("Interpreters have taken it in the sense of origin, the righteousness which proceeds from God;"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn11-22"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/v1_Chapter03#fn11-22"
    }
  }, [_vm._v("22")])]), _vm._v(" others in the sense that it is the righteousness which God approves;"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn11-23"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/v1_Chapter03#fn11-23"
    }
  }, [_vm._v("23")])]), _vm._v(" others in the sense that it is the righteousness that avails with God and is therefore effective to the end contemplated."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn11-24"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/v1_Chapter03#fn11-24"
    }
  }, [_vm._v("24")])]), _vm._v(" All of these observations are in themselves true. But it is questionable if any or all of them have focused attention upon what is perhaps the most important consideration, namely, that it is a righteousness that sustains a much closer relationship to God in respect of possession and property than these other notions express. It is not the attribute of justice for the reasons given. Yet it is so intimately related to God that it is "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_31",
      "title": "31"
    }
  }, [_vm._v("a righteousness of divine property and characterized by divine qualities. It is a “God-righteousness”. Because it is such, God is its author; it is a righteousness that must elicit the divine approval; it is a righteousness that meets all the demands of his justice and therefore avails before God. But the particular emphasis rests upon its divine property and is therefore contrasted not only with human unrighteousness but with human righteousness. Manrighteousness, even though perfect and measuring up to all the demands of God’s perfection, would never be adequate to the situation created by our sins. This is the glory of the gospel; as it is God’s power operative unto salvation so is it God’s righteousness supervening upon our sin and ruin. And it is God’s power operative unto salvation "), _c('i', [_vm._v("because")]), _vm._v(" the righteousness of God is dynamically made manifest unto our justification. Nothing serves to point up the effectiveness, completeness, and irrevocableness of the justification which it is the apostle’s purpose to establish and vindicate than this datum set forth at the outset—the righteousness which is unto justification is one characterized by the perfection belonging to all that God is and does. It is a “God-righteousness”.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("The mediacy or instrumentality of faith is again brought to the forefront. “From faith unto faith” in verse 17 is to the same effect as “to every one that believeth” in verse 16. There is much difference of opinion as to the precise intent of this formula. It has been interpreted as referring to the advance from one degree of faith to another"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn11-25"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/v1_Chapter03#fn11-25"
    }
  }, [_vm._v("25")])]), _vm._v(" or as equivalent to “by faith alone”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn11-26"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/v1_Chapter03#fn11-26"
    }
  }, [_vm._v("26")])]), _vm._v(" or as implying that the righteousness of God is by faith from beginning to end."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn11-27"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/v1_Chapter03#fn11-27"
    }
  }, [_vm._v("27")])]), _vm._v(" It would appear that the clue to the interpretation is provided by Paul himself in a passage that furnishes the closest parallel, namely, 3:22 ("), _c('i', [_vm._v("cf")]), _vm._v(". Gal. 3:22)."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn11-28"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/v1_Chapter03#fn11-28"
    }
  }, [_vm._v("28")])]), _vm._v(" There he speaks of “the righteousness of God through faith of Jesus Christ unto all who believe”. It might seem that the expression “unto all who believe” is superfluous in this instance because all that it sets "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_32",
      "title": "32"
    }
  }, [_vm._v("forth has been already stated in the expression which immediately precedes, “through faith of Jesus Christ”. But the apostle must have some purpose in what seems to us repetition. And the purpose is to accent the fact that not only does the righteousness of God bear savingly upon us "), _c('i', [_vm._v("through faith")]), _vm._v(" but also that it bears savingly upon "), _c('i', [_vm._v("every one")]), _vm._v(" who believes. It is not superfluous to stress both. For the mere fact that the righteousness of God is through faith does not of itself as a proposition guarantee that faith always carries with it this effect. We found already that the apostle laid stress on this in verse 16 when he said “to "), _c('i', [_vm._v("every one")]), _vm._v(" that believeth”. And the most reasonable view appears to be that this same emphasis is intended by the formula “from faith to faith”. “From faith” points to the truth that only “by faith” are we the beneficiaries of this righteousness, and so it is a “faith-righteousness” as truly as it is a “God-righteousness”. “To faith” underlines the truth that every believer is the beneficiary whatever his race or culture or the degree of his faith. Faith "), _c('i', [_vm._v("always")]), _vm._v(" carries with it the justifying righteousness of God."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn11-29"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/v1_Chapter03#fn11-29"
    }
  }, [_vm._v("29")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("It is not unreasonable to take “from faith to faith” in construction with “a righteousness of God”. For since this righteousness is operative unto salvation only through faith it can properly be designated a righteousness of faith to all who believe. It is more natural, however, to couple “from faith to faith” with the word “revealed”. The dynamic force of the word “revealed” relieves this construction of an objection which might be urged against it, namely, that revelation as such is not dependent upon faith. With the dynamic import of the term “revealed” in mind, however, the thought expressed is that the righteousness of God is efficiently made known unto justification only through faith and that it is invariably operative to this end in the case of every one that believes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("The appeal to Habakkuk 2:4"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn11-30"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/v1_Chapter03#fn11-30"
    }
  }, [_vm._v("30")])]), _vm._v(" is for the purpose of confirmation "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_33",
      "title": "33"
    }
  }, [_vm._v("from the Old Testament."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn11-31"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/v1_Chapter03#fn11-31"
    }
  }, [_vm._v("31")])]), _vm._v(" Discussion has turned on the question of the proper rendering, whether “by faith” is to be taken with the subject of the sentence or with the predicate. Are we to render the proposition, “The righteous by faith shall live”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn11-32"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/v1_Chapter03#fn11-32"
    }
  }, [_vm._v("32")])]), _vm._v(" or “The righteous shall live by faith”? Is the proposition to the effect that the righteous will live or to the effect of intimating how the righteous will live, namely, by faith? There are good reasons for the latter alternative. (1) Habakkuk 2:4 cannot naturally be interpreted any other way and the massoretic interpunctuation favours this view. (2) The truth being established by the apostle is that the righteousness of God is by faith—the emphasis rests upon the way in which man becomes the beneficiary of this righteousness. We should expect that the reference to “faith” in the quotation would have the same force. (3) The expression “the righteous by faith” is not one that can plead the analogy of Scripture usage."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn11-33"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/v1_Chapter03#fn11-33"
    }
  }, [_vm._v("33")])])])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "id": "page_26f"
    }
  }, [_c('sup')]), _c('a', {
    attrs: {
      "id": "fn11-20"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/v1_Chapter03#rfn11-20"
    }
  }, [_vm._v("20")]), _c('span', {
    staticClass: "fnsp"
  }, [_c('i', [_vm._v("τοῦ Xϱιστoῦ")]), _vm._v(" is added to "), _c('i', [_vm._v("τo εὐaγγέλιov")]), _vm._v(" in D"), _c('sup', [_c('i', [_vm._v("c")])]), _c('span', {
    staticClass: "fnsp1"
  }, [_vm._v("K L P and some other authorities. But the omission in ℵ A B C D* E G, several cursives and versions should be regarded as sufficiently weighty evidence against this reading. Moreover, it is easier to understand the addition than the omission in the course of transmission.")])])]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "id": "page_27f"
    }
  }, [_c('sup')]), _c('a', {
    attrs: {
      "id": "fn11-21"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/v1_Chapter03#rfn11-21"
    }
  }, [_vm._v("21")]), _c('span', {
    staticClass: "fnsp1"
  }, [_vm._v("The priority of effectual calling and of regeneration in the "), _c('i', [_vm._v("ordo salutis")]), _vm._v(" should not be allowed to prejudice this truth either in our thinking or in the preaching of the gospel. It is true that regeneration is causally prior to faith. But it is only "), _c('i', [_vm._v("causally")]), _vm._v(" prior and the adult person who is regenerated always exercises faith. Hence the salvation which is of the gospel is never ours apart from faith. This is true even in the case of infants, for in regeneration the germ of faith is implanted. There is order in the application of redemption, but it is order in that which constitutes an indissoluble unity comprising a variety of elements. It is salvation in its integral unity of which the apostle speaks and this is never ours without faith—we are saved by grace through faith (Eph. 2:8). The person who is "), _c('i', [_vm._v("merely")]), _vm._v(" regenerate is not saved, the simple reason being that there is no such person. The saved person is "), _c('i', [_vm._v("also")]), _vm._v(" called, justified, and adopted. It is not only pertinent to the apostle’s doctrine of salvation that he should lay such emphasis upon faith but also particularly appropriate to what is the leading theme of the early part of this epistle, namely, justification. It is preeminently in connection with justification that the accent falls upon faith.")])]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "id": "page_30f"
    }
  }, [_c('sup')]), _c('a', {
    attrs: {
      "id": "fn11-22"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/v1_Chapter03#rfn11-22"
    }
  }, [_vm._v("22")]), _c('span', {
    staticClass: "fnsp1"
  }, [_vm._v("The genitive "), _c('i', [_vm._v("θεοῦ")]), _vm._v(" being that of origin or author; "), _c('i', [_vm._v("cf., e. g.,")]), _vm._v(" Meyer, "), _c('i', [_vm._v("ad loc.")])])]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('sup', [_c('a', {
    attrs: {
      "id": "fn11-23"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/v1_Chapter03#rfn11-23"
    }
  }, [_vm._v("23")])]), _c('span', {
    staticClass: "fnsp1"
  }, [_c('i', [_vm._v("Cf.")]), _vm._v(" Calvin, "), _c('i', [_vm._v("ad loc.")])])]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('sup', [_c('a', {
    attrs: {
      "id": "fn11-24"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/v1_Chapter03#rfn11-24"
    }
  }, [_vm._v("24")])]), _c('span', {
    staticClass: "fnsp1"
  }, [_c('i', [_vm._v("Cf.")]), _vm._v(" Philippi, "), _c('i', [_vm._v("ad loc.")])])]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "id": "page_31f"
    }
  }, [_c('sup')]), _c('a', {
    attrs: {
      "id": "fn11-25"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/v1_Chapter03#rfn11-25"
    }
  }, [_vm._v("25")]), _c('span', {
    staticClass: "fnsp1"
  }, [_c('i', [_vm._v("Cf.")]), _vm._v(" Calvin, "), _c('i', [_vm._v("ad loc.")])])]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('sup', [_c('a', {
    attrs: {
      "id": "fn11-26"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/v1_Chapter03#rfn11-26"
    }
  }, [_vm._v("26")])]), _c('span', {
    staticClass: "fnsp1"
  }, [_c('i', [_vm._v("Cf.")]), _vm._v(" Charles Hodge: "), _c('i', [_vm._v("op cit., ad loc.:")]), _vm._v(" “The sense is however perfectly clear and good, if the phrase is explained to mean, faith alone. As ‘death unto death’ and ‘life unto life’ are intensive, so ‘faith unto faith’ may mean, entirely of faith” (p. 32); Anders Nygren; "), _c('i', [_vm._v("Commentary on Romans")]), _vm._v(" (E. T., Philadelphia, 1949), pp. 78f.")])]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('sup', [_c('a', {
    attrs: {
      "id": "fn11-27"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/v1_Chapter03#rfn11-27"
    }
  }, [_vm._v("27")])]), _c('span', {
    staticClass: "fnsp1"
  }, [_c('i', [_vm._v("Cf.")]), _vm._v(" C. H. Dodd: "), _c('i', [_vm._v("op. cit., ad loc.")])])]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('sup', [_c('a', {
    attrs: {
      "id": "fn11-28"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/v1_Chapter03#rfn11-28"
    }
  }, [_vm._v("28")])]), _c('span', {
    staticClass: "fnsp1"
  }, [_c('i', [_vm._v("Cf.")]), _vm._v(" Philippi, "), _c('i', [_vm._v("ad loc.")])])]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "id": "page_32f"
    }
  }, [_c('sup')]), _c('a', {
    attrs: {
      "id": "fn11-29"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/v1_Chapter03#rfn11-29"
    }
  }, [_vm._v("29")]), _c('span', {
    staticClass: "fnsp1"
  }, [_vm._v("In more recent times the view has been presented that ἐϰ "), _c('i', [_vm._v("πίστεως")]), _vm._v(" refers to God’s faithfulness and "), _c('i', [_vm._v("εἰς πίστιv to")]), _vm._v(" man’s faith. "), _c('i', [_vm._v("Cf.")]), _vm._v(" Thomas F. Torrance: “One Aspect of the Biblical Conception of Faith” in "), _c('i', [_vm._v("The Expository Times, January,")]), _vm._v(" 1957 (Vol. LXVIII, 4), pp. 111–114. This view is discussed in Appendix B, (pp. 363 ff.). Meyer: "), _c('i', [_vm._v("op. cit., ad loc.")]), _vm._v(" refers to Mehring as holding the view that "), _c('i', [_vm._v("εἰς πίστιv")]), _vm._v(" refers to the faithfulness of God and that the whole expression means faith in the faithfulness of God.")])]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('sup', [_c('a', {
    attrs: {
      "id": "fn11-30"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/v1_Chapter03#rfn11-30"
    }
  }, [_vm._v("30")])]), _c('span', {
    staticClass: "fnsp1"
  }, [_vm._v("For a discussion of this passage and the meaning of "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("אמױה")]), _vm._v(" and "), _c('i', [_vm._v("πίστιζ cf.")]), _vm._v(" J. B. Lightfoot: "), _c('i', [_vm._v("Saint Paul’s Epistle to the Galatians")]), _vm._v(" (London, 1905), pp. 154–158.")])]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "id": "page_33f"
    }
  }, [_c('sup')]), _c('a', {
    attrs: {
      "id": "fn11-31"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/v1_Chapter03#rfn11-31"
    }
  }, [_vm._v("31")]), _c('span', {
    staticClass: "fnsp1"
  }, [_vm._v("“The apostle is so convinced of the unity which prevails between the old and new covenants, that he cannot assert one of the great truths of the gospel without quoting a passage from the Old Testament in its support” (Godet: "), _c('i', [_vm._v("op. cit., ad loc.")]), _vm._v(").")])]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('sup', [_c('a', {
    attrs: {
      "id": "fn11-32"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/v1_Chapter03#rfn11-32"
    }
  }, [_vm._v("32")])]), _c('span', {
    staticClass: "fnsp1"
  }, [_vm._v("For a vigorous more recent defence of this construction "), _c('i', [_vm._v("cf.")]), _vm._v(" Anders Nygren: "), _c('i', [_vm._v("op. cit.,")]), _vm._v(" pp. 84ff.")])]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('sup', [_c('a', {
    attrs: {
      "id": "fn11-33"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/v1_Chapter03#rfn11-33"
    }
  }, [_vm._v("33")])]), _c('span', {
    staticClass: "fnsp1"
  }, [_vm._v("J. B. Lightfoot’s observations in his "), _c('i', [_vm._v("Notes on the Epistles of St. Paul")]), _vm._v(" (London, 1895) sums up the arguments in favour of this interpretation admirably. “I cannot doubt that ἐϰ "), _c('i', [_vm._v("πίστεως")]), _vm._v(" is to be taken with "), _c('i', [_vm._v("ζήσετaι,")]), _vm._v(" not with ὁ "), _c('i', [_vm._v("δίϰαιος.")]), _vm._v(" For (1) the original seems certainly so to intend it. . . . (2) "), _c('i', [_vm._v("ἐϰ πίστεως")]), _vm._v(" here corresponds to "), _c('i', [_vm._v("ἐϰ πίστεως")]), _vm._v(" in the former part of the verse, where it belongs, not to the predicate, but to the subject. It is here separated from "), _c('i', [_vm._v("ὁ δίϰaιoς")]), _vm._v(" as it is there separated from "), _c('i', [_vm._v("διϰαιοσύνη.")]), _vm._v(" (3) "), _c('i', [_vm._v("ὁ δίϰαιος ἐϰ πίστεως")]), _vm._v(" is not a natural phrase, and, I think, has no parallel in St. Paul. (4) The other construction takes the emphasis off ‘faith,’ which the context shows to be the really emphatic word, and lays it on the verb ‘live.’ In Gal. iii. 11 the context is still more decisive” (pp. 250f.).")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58778990","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/v1_Chapter03.vue
// module id = 87
// module chunks = 0